import { ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { erasmusRequests } from "api/erasmusApi";
import { administrationRequests } from "api/administrationApi";

const SaveErasmusCoordinatorsForm = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <EmployeeInput
          source="employeeId"
          label="Служител"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="structuralUnitId"
          reference={administrationRequests.getStructuralUnitsSelect()}
        >
          <SelectInput
            label="Структурна единица"
            validate={required()}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="status"
          reference={erasmusRequests.getCoordinatorStatusesSelect()}
        >
          <SelectInput
            label="Статус"
            optionText="nameBg"
            validate={required()}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          label="Адрес (на латиница)"
          source="addressEn"
          validate={required()}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default SaveErasmusCoordinatorsForm;
